import { UserOutlined } from '@ant-design/icons';
import { AButton, AModal, ATitle } from '../../../components';
import { ISchedule } from '../../../shared/interfaces';
import { Avatar, List } from 'antd';
import { ContainerListShedules } from './styles';
import { ContainerDescriptionList, DescriptionText } from '../styles';

interface ISchedulesDayProps {
  open: boolean;
  close: () => void;
  events: ISchedule[];
}

const SchedulesDay: React.FC<ISchedulesDayProps> = ({
  open,
  close,
  events,
}) => {
  return (
    <AModal
      open={open}
      close={close}
      title={<ATitle>Agendamentos para hoje!</ATitle>}
      footer={
        <>
          <AButton onClick={close}>Fechar</AButton>
        </>
      }
    >
      <ContainerListShedules>
        <List
          dataSource={events}
          size="large"
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <Avatar
                    icon={<UserOutlined />}
                    style={{ backgroundColor: item.color }}
                  />
                }
                title={item.title}
                description={
                  <ContainerDescriptionList>
                    <DescriptionText>
                      Horário{' '}
                      {`${String(new Date(item.start).getUTCHours()).padStart(2, '0')}:${String(new Date(item.start).getUTCMinutes()).padStart(2, '0')}`}{' '}
                      às{' '}
                      {`${String(new Date(item.end).getUTCHours()).padStart(2, '0')}:${String(new Date(item.end).getUTCMinutes()).padStart(2, '0')}`}
                    </DescriptionText>
                    <DescriptionText>
                      Situação: {item.description_status}
                    </DescriptionText>
                    <DescriptionText>
                      Profissional: {item.professional_name}
                    </DescriptionText>
                    <DescriptionText>
                      Observação: {item.observation ?? 'Sem informação'}
                    </DescriptionText>
                  </ContainerDescriptionList>
                }
              />
            </List.Item>
          )}
        />
      </ContainerListShedules>
    </AModal>
  );
};

export default SchedulesDay;
